import { DocProperty } from 'typescript-openapi-router';

export class RequestParameters {
  @DocProperty({
    type: 'string',
    isRequired: true,
  })
  sourceIPAddress: string;
}
